import { Check, Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import Select from "react-select";
import {
  formatCpfCnpj,
  formatCep,
  consultarCep,
  formatTelefone,
  formatContaContabil,
  formatMulta,
  formatValor,
  formatNumber,
  consultarCnpjHelper,
} from "../../helpers/formaters";
import { ESTADOS_BRASIL } from "../../helpers/estados";

export const FilterCadastroFornecedor = (props) => {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 12,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "12px",
      textAlign: "left",
      '&[type="date"]': {
        fontSize: "14px",
      },
      "&.Mui-readOnly": {
        fontSize: "12px",
        "-webkit-text-fill-color": "inherit",
      },
      "&::placeholder": {
        fontSize: "12px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
      "& .MuiFormLabel-asterisk": {
        color: "red",
        fontWeight: "bold",
      },
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  return (
    <Box>
      {/* <Box> */}
      {/* <Paper> */}
      <Box>
        {props.isSearch ? (
          <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
            <Box
              sx={{
                px: 2,
                py: 0.5,
                bgcolor: "#669966",
                color: "white",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Consulta de Fornecedores
            </Box>

            <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
              <Grid container spacing={0.75} alignItems="flex-end">
                <Grid size={{ xs: 12, sm: 10 }}>
                  <TextField
                    sx={textFieldStyles}
                    label="Buscar fornecedor"
                    size="small"
                    fullWidth
                    color="success"
                    value={props.searchValue}
                    onChange={(e) => props.setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") props.searchFornec();
                    }}
                  />
                </Grid>

                <Grid
                  size={{ xs: 12, sm: 2 }}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                  }}
                >
                  <IconButton
                    onClick={() => props.searchFornec()}
                    className={css(styles.btn)}
                    title="Buscar"
                  >
                    <Search fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        ) : (
          <Grid container spacing={1.5} alignItems="stretch">
            <Grid
              size={{ xs: 12, md: 8 }}
              sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
            >
              <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
                <Box
                  sx={{
                    px: 2,
                    py: 0.5,
                    bgcolor: "#669966",
                    color: "white",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Informações Principais
                </Box>

                <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
                  <Grid container spacing={0.75} alignItems="flex-end">
                    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="CNPJ / CPF"
                        size="small"
                        required
                        fullWidth
                        color="success"
                        inputRef={props.cnpjCpfRef}
                        error={props.errors.cnpjCpf}
                        value={props.cnpjCpf}
                        onChange={(e) => {
                          props.setCnpjCpf(formatCpfCnpj(e.target.value));
                          props.setErrors((prev) => ({
                            ...prev,
                            cnpjCpf: false,
                          }));
                        }}
                        onBlur={(e) => {
                          consultarCnpjHelper(e.target.value, (dados) => {
                            props.setRazaoSocial(dados.razao_social);
                            props.setNomeFantasia(dados.nome_fantasia);
                            props.setTelefone1(
                              formatTelefone(dados.ddd_telefone_1),
                            );
                            props.setTelefone2(
                              formatTelefone(dados.ddd_telefone_2),
                            );
                            props.setFax(dados.ddd_fax);
                            props.setCep(formatCep(dados.cep));
                            props.setLogradouro(dados.logradouro);
                            props.setNumero(dados.numero);
                            props.setComplemento(dados.complemento);
                            props.setBairro(dados.bairro);
                            props.setCidade(dados.municipio);
                            props.setEstado(dados.uf);
                            props.setCodigoCidade(dados.codigo_municipio);
                          });
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Razão Social"
                        required
                        size="small"
                        inputRef={props.razaoSocialRef}
                        error={props.errors.razaoSocial}
                        fullWidth
                        color="success"
                        value={props.razaoSocial}
                        onChange={(e) => {
                          props.setRazaoSocial(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            razaoSocial: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 9, md: 5, lg: 4 }}>
                      <TextField
                        sx={{
                          ...textFieldStyles,
                          "& .MuiSelect-select": {
                            cursor: "pointer !important",
                          },
                        }}
                        fullWidth
                        select
                        color="success"
                        required
                        label="Tipo Fornecedor"
                        inputRef={props.tipoFornecRef}
                        error={props.errors.tipoFornec}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  fontSize: "11px",
                                  minHeight: "24px",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                              },
                            },
                          },
                          renderValue: (value) => {
                            const f = (props.tipoFornecList || []).find(
                              (x) => String(x.id) === String(value),
                            );
                            return f ? f.name : "";
                          },
                        }}
                        size="small"
                        value={props.tipoFornec}
                        onChange={(e) => {
                          props.setTipoFornec(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            tipoFornec: false,
                          }));
                        }}
                      >
                        {(props.tipoFornecListAtivos || []).map((tipo) => (
                          <MenuItem key={tipo.id} value={tipo.id}>
                            {tipo.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 3, lg: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={props.exterior}
                            onChange={(e) =>
                              props.setExterior(e.target.checked)
                            }
                            color="success"
                          />
                        }
                        label="Exterior"
                        componentsProps={{
                          typography: {
                            fontSize: 11,
                            fontFamily: "Poppins",
                          },
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4, lg: 6 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Nome Fantasia"
                        size="small"
                        inputRef={props.nomeFantasiaRef}
                        error={props.errors.nomeFantasia}
                        fullWidth
                        required
                        color="success"
                        value={props.nomeFantasia}
                        onChange={(e) => {
                          props.setNomeFantasia(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            nomeFantasia: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Sigla"
                        size="small"
                        inputRef={props.siglaRef}
                        error={props.errors.sigla}
                        fullWidth
                        required
                        color="success"
                        value={props.sigla}
                        onChange={(e) => {
                          props.setSigla(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            sigla: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 8, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Contato"
                        size="small"
                        inputRef={props.contatoRef}
                        error={props.errors.contato}
                        fullWidth
                        required
                        color="success"
                        value={props.contato}
                        onChange={(e) => {
                          props.setContato(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            contato: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Celular"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.celular}
                        onChange={(e) =>
                          props.setCelular(formatTelefone(e.target.value))
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Telefone 1"
                        size="small"
                        inputRef={props.telefone1Ref}
                        error={props.errors.telefone1}
                        fullWidth
                        color="success"
                        value={props.telefone1}
                        required
                        onChange={(e) => {
                          props.setTelefone1(formatTelefone(e.target.value));
                          props.setErrors((prev) => ({
                            ...prev,
                            telefone1: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Telefone 2"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.telefone2}
                        onChange={(e) =>
                          props.setTelefone2(formatTelefone(e.target.value))
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="FAX"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.fax}
                        onChange={(e) => props.setFax(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Paper>

              <Paper
                sx={{ mt: 1, borderRadius: 1, overflow: "hidden" }}
                elevation={1}
              >
                <Box
                  sx={{
                    px: 2,
                    py: 0.5,
                    bgcolor: "#669966",
                    color: "white",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Endereço
                </Box>

                <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 2.5, md: 3, xl: 2 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="CEP"
                        size="small"
                        fullWidth
                        required
                        color="success"
                        inputRef={props.cepRef}
                        error={props.errors.cep}
                        value={props.cep}
                        onChange={async (e) => {
                          const formattedCep = formatCep(e.target.value);
                          props.setCep(formattedCep);

                          if (formattedCep.length === 9) {
                            const data = await consultarCep(formattedCep);

                            if (data) {
                              props.setLogradouro(data.logradouro || "");
                              props.setBairro(data.bairro || "");
                              props.setCidade(data.localidade || "");
                              props.setCodigoCidade(data.ibge || "");
                              props.setPais("Brasil");

                              const uf = (data.uf || "").toUpperCase();
                              const existe = ESTADOS_BRASIL.some(
                                (e) => e.sigla === uf,
                              );

                              if (existe) props.setEstado(uf);
                            }
                            props.setErrors((prev) => ({
                              ...prev,
                              cep: false,
                            }));
                          }
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 7, md: 7, xl: 8 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Logradouro"
                        size="small"
                        inputRef={props.logradouroRef}
                        error={props.errors.logradouro}
                        fullWidth
                        required
                        color="success"
                        value={props.logradouro}
                        onChange={(e) => {
                          props.setLogradouro(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            logradouro: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 2.5, md: 2, xl: 2 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Número"
                        size="small"
                        inputRef={props.numeroRef}
                        error={props.errors.numero}
                        fullWidth
                        required
                        color="success"
                        value={props.numero}
                        onChange={(e) => {
                          props.setNumero(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            numero: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4.75, md: 7, xl: 6 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Complemento"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.complemento}
                        onChange={(e) => {
                          props.setComplemento(e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4.75, md: 5, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Bairro"
                        required
                        inputRef={props.bairroRef}
                        error={props.errors.bairro}
                        size="small"
                        fullWidth
                        color="success"
                        value={props.bairro}
                        onChange={(e) => {
                          props.setBairro(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            bairro: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 2.5, md: 2.25, xl: 2 }}>
                      <TextField
                        fullWidth
                        select
                        color="success"
                        sx={textFieldStyles}
                        label="Estado"
                        required
                        inputRef={props.estadoRef}
                        error={props.errors.estado}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  fontSize: "11px",
                                  minHeight: "24px",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                              },
                            },
                          },
                        }}
                        size="small"
                        value={props.estado ?? ""}
                        onChange={(e) => {
                          props.setEstado(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            estado: false,
                          }));
                        }}
                      >
                        {ESTADOS_BRASIL.map((est) => (
                          <MenuItem key={est.sigla} value={est.sigla}>
                            {est.sigla}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 2, xl: 1.5 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Cód. Cidade"
                        required
                        inputRef={props.codigoCidadeRef}
                        size="small"
                        fullWidth
                        color="success"
                        value={props.codigoCidade}
                        onChange={(e) => {
                          props.setCodigoCidade(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            codigoCidade: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 3, xl: 3 }}>
                      <TextField
                        sx={textFieldStyles}
                        required
                        label="Cidade"
                        inputRef={props.cidadeRef}
                        size="small"
                        fullWidth
                        color="success"
                        value={props.cidade}
                        onChange={(e) => {
                          props.setCidade(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            cidade: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 1.75, xl: 1.5 }}>
                      <TextField
                        sx={textFieldStyles}
                        required
                        label="Cód. País"
                        inputRef={props.codigoPaisRef}
                        size="small"
                        fullWidth
                        color="success"
                        value={props.codigoPais}
                        onChange={(e) => {
                          props.setCodigoPais(e.target.value);
                          props.setErrors((prev) => ({
                            ...prev,
                            codigoPais: false,
                          }));
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 3, xl: 2 }}>
                      <TextField
                        label="País"
                        required
                        inputRef={props.paisRef}
                        size="small"
                        fullWidth
                        color="success"
                        value={props.pais || ""}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{
                          ...textFieldStyles,
                          "& .MuiInputBase-root": {
                            bgcolor: "rgba(0, 0, 0, 0.14)",
                            cursor: "default",
                          },
                          "& .MuiInputLabel-root": {
                            color: "text.secondary",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "divider",
                          },
                          "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "divider",
                            },
                          "& input": {
                            fontSize: "13px",
                            caretColor: "transparent",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Paper>

              <Paper
                sx={{ mt: 1, borderRadius: 1, overflow: "hidden" }}
                elevation={1}
              >
                <Box
                  sx={{
                    px: 2,
                    py: 0.5,
                    bgcolor: "#669966",
                    color: "white",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Detalhes
                </Box>

                <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid size={{ xs: 12, sm: 4, md: 4, xl: 3.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="Inscrição Estadual (CFG)"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.inscricaoEstadual}
                        onChange={(e) =>
                          props.setInscricaoEstadual(e.target.value)
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 8, md: 8, xl: 5 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="E-mail"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.email}
                        onChange={(e) => props.setEmail(e.target.value)}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 2, xl: 1.5 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="ICMS"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.icms}
                        onChange={(e) => props.setIcms(e.target.value)}
                        onBlur={(e) =>
                          props.setIcms(formatMulta(e.target.value, true))
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3, md: 2.5, xl: 2.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        label="% PK Padrão"
                        size="small"
                        fullWidth
                        color="success"
                        value={props.pkPadrao}
                        onChange={(e) => props.setPkPadrao(e.target.value)}
                        onBlur={(e) =>
                          props.setPkPadrao(formatNumber(e.target.value, true))
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 7.5, xl: 4 }}>
                      <TextField
                        sx={{
                          ...textFieldStyles,
                          "& .MuiSelect-select": {
                            cursor: "pointer !important",
                          },
                        }}
                        fullWidth
                        select
                        color="success"
                        label="Centro de Custos"
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  fontSize: "11px",
                                  minHeight: "24px",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                              },
                            },
                          },
                          renderValue: (value) => {
                            const f = (props.centroCustoList || []).find(
                              (x) => String(x.id) === String(value),
                            );
                            return f ? f.name : "";
                          },
                        }}
                        size="small"
                        value={props.centroCusto}
                        onChange={(e) => props.handleChangeCentroCusto(e)}
                      >
                        {(props.centroCustoListAtivos || []).map(
                          (centroCusto) => (
                            <MenuItem
                              key={centroCusto.id}
                              value={centroCusto.id}
                            >
                              {centroCusto.name}
                            </MenuItem>
                          ),
                        )}
                      </TextField>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 6, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        select
                        color="success"
                        label="Despesa"
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  fontSize: "11px",
                                  minHeight: "24px",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                              },
                            },
                          },
                          renderValue: (value) => {
                            const f = (props.despesaList || []).find(
                              (x) => String(x.id) === String(value),
                            );
                            return f ? f.name : "";
                          },
                        }}
                        size="small"
                        value={props.despesa}
                        onChange={(e) => props.handleChangeDespesa(e)}
                      >
                        {(props.despesaListAtivos || []).map((despesa) => (
                          <MenuItem key={despesa.id} value={despesa.id}>
                            {despesa.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 6, xl: 4 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        select
                        color="success"
                        label="Conta Contábil"
                        size="small"
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  fontSize: "11px",
                                  minHeight: "24px",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                              },
                            },
                          },
                          renderValue: (value) => {
                            const f = (props.planoContasList || []).find(
                              (x) => String(x.id) === String(value),
                            );
                            return f ? f.name : "";
                          },
                        }}
                        value={props.contaContabil}
                        onChange={(e) => props.setContaContabil(e.target.value)}
                      >
                        {(props.planoContasListAtivos || []).map(
                          (planoContas) => (
                            <MenuItem
                              key={planoContas.id}
                              value={planoContas.id}
                              disabled={!planoContas.analitica}
                              sx={{
                                fontWeight: planoContas.analitica
                                  ? "normal"
                                  : "bold",
                                backgroundColor: planoContas.analitica
                                  ? "transparent"
                                  : "#f5f5f5",
                              }}
                            >
                              {planoContas.id} - {planoContas.name}
                            </MenuItem>
                          ),
                        )}
                      </TextField>
                    </Grid>

                    {/* <Grid size={{ xs: 12 }}>
                      <Box
                        component="fieldset"
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          minHeight: 78,
                        }}
                      >
                        <Box
                          component="legend"
                          sx={{
                            px: 1,
                            fontSize: 12,
                            color: "text.secondary",
                            fontFamily: "Poppins",
                          }}
                        >
                          Conta Vinculada
                        </Box>

                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, sm: 5, md: 5, xl: 5 }}>
                            <TextField
                              sx={{
                                ...textFieldStyles,
                                "& .MuiSelect-select": {
                                  cursor: "pointer !important",
                                },
                              }}
                              fullWidth
                              select
                              color="success"
                              label="Agente Financeiro"
                              size="small"
                              value={props.agenteFinanceiro}
                              onChange={(e) =>
                                props.setAgenteFinanceiro(e.target.value)
                              }
                            >
                              {props.agenteFinanceiroList?.map(
                                (agenteFinanceiro) => (
                                  <MenuItem
                                    key={agenteFinanceiro.id}
                                    value={agenteFinanceiro.id}
                                  >
                                    {agenteFinanceiro.name}
                                  </MenuItem>
                                ),
                              )}
                            </TextField>
                          </Grid>

                          <Grid size={{ xs: 12, sm: 3.5, md: 3.5, xl: 3.5 }}>
                            <TextField
                              sx={{
                                ...textFieldStyles,
                                "& .MuiSelect-select": {
                                  cursor: "pointer !important",
                                },
                              }}
                              fullWidth
                              select
                              color="success"
                              label="Agência"
                              size="small"
                              value={props.agencia}
                              onChange={(e) => props.setAgencia(e.target.value)}
                            >
                              {props.agenciaList?.map((agencia) => (
                                <MenuItem key={agencia.id} value={agencia.id}>
                                  {agencia.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>

                          <Grid size={{ xs: 12, sm: 3.5, md: 3.5, xl: 3.5 }}>
                            <TextField
                              sx={{
                                ...textFieldStyles,
                                "& .MuiSelect-select": {
                                  cursor: "pointer !important",
                                },
                              }}
                              fullWidth
                              select
                              color="success"
                              label="C. Corrente"
                              size="small"
                              value={props.corrente}
                              onChange={(e) =>
                                props.setCorrente(e.target.value)
                              }
                            >
                              {props.correnteList?.map((corrente) => (
                                <MenuItem key={corrente.id} value={corrente.id}>
                                  {corrente.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid> */}

                    <Grid size={{ xs: 12 }}>
                      <Grid container spacing={2}>
                        {[
                          {
                            label: "Isento ICMS",
                            value: props.isentoIcms,
                            setter: props.setIsentoIcms,
                          },
                          {
                            label: "Aceita Devolução",
                            value: props.aceitaDevolucao,
                            setter: props.setAceitaDevolucao,
                          },
                          {
                            label: "Fabricante",
                            value: props.fabricante,
                            setter: props.setFabricante,
                          },
                          {
                            label: "Frete",
                            value: props.frete,
                            setter: props.setFrete,
                          },
                        ].map((item, index) => (
                          <Grid
                            key={index}
                            size={{ xs: 12, sm: 6, md: 6, lg: 3, xl: 3 }}
                          >
                            <Box
                              component="fieldset"
                              sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1.5,
                                minHeight: 54,
                              }}
                            >
                              <Box
                                component="legend"
                                sx={{
                                  fontSize: 12,
                                  color: "text.secondary",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {item.label}
                              </Box>

                              <RadioGroup
                                row
                                value={item.value}
                                onChange={(e) => item.setter(e.target.value)}
                                sx={{
                                  mt: -0.5,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  px: 0.5,
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: 12,
                                  },
                                }}
                              >
                                <FormControlLabel
                                  value="S"
                                  control={
                                    <Radio color="success" size="small" />
                                  }
                                  label="Sim"
                                />
                                <FormControlLabel
                                  value="N"
                                  control={
                                    <Radio color="success" size="small" />
                                  }
                                  label="Não"
                                />
                              </RadioGroup>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
              <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
                <Box
                  sx={{
                    px: 2,
                    py: 0.5,
                    bgcolor: "#cee6ceff",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Visão Geral
                </Box>

                <Box sx={{ p: 1.5 }}>
                  <Typography sx={{ fontWeight: 700, mb: 0.5, fontSize: 14 }}>
                    {props.razaoSocial || "Fornecedor"}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.nomeFantasia || "Nome fantasia"}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.cnpjCpf || "CNPJ/CPF"}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.celular || "Celular"}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.cidade
                      ? `${props.cidade}${props.estado ? " - " : ""}${
                          props.estado || ""
                        }`
                      : "Cidade/UF"}
                  </Typography>
                  <Divider sx={{ my: 1.5 }} />
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.logradouro || "Logradouro"}
                    {props.numero ? `, ${props.numero}` : ""}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    {props.bairro || "Bairro"}{" "}
                    {props.cep ? `• ${props.cep}` : ""}
                  </Typography>
                </Box>
              </Paper>
              <Grid
                size={{ xs: 12 }}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: { md: "column", lg: "row" },
                  gap: 1,
                  mt: 1,
                }}
              >
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ minWidth: 120, fontSize: 12 }}
                  onClick={() => props.handleBack()}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => props.cadFornec()}
                  sx={{ minWidth: 120, fontSize: 12, bgcolor: "#669966" }}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
      {/* </Paper> */}
      {/* </Box> */}
    </Box>
  );
};

const styles = StyleSheet.create({
  input: {
    fontFamily: "Poppins !important",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 30,
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,

    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 34,
  },
  erro: {
    // fontFamily: "Poppins",
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
});
